import { render, staticRenderFns } from "./ApplicationAgreementPanel.vue?vue&type=template&id=007c0b3b&scoped=true&"
import script from "./ApplicationAgreementPanel.vue?vue&type=script&lang=js&"
export * from "./ApplicationAgreementPanel.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationAgreementPanel.vue?vue&type=style&index=0&id=007c0b3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007c0b3b",
  null
  
)

export default component.exports